var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grades-chart-component"},[_c('b-tabs',{attrs:{"animated":false},model:{value:(_vm.activeChart),callback:function ($$v) {_vm.activeChart=$$v},expression:"activeChart"}},[_c('b-tab-item',{attrs:{"label":"Submitted"}},[_c('submitted-chart')],1),_c('b-tab-item',{attrs:{"label":"Overdue"}},[_c('overdue-chart')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }